function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "eco");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.794 19.516q-3.478 6.958-14.689 8.118h-0.129c-0.644 0-1.16-0.516-1.289-1.16-0.129-0.773 0.515-1.289 1.159-1.417 6.443-0.644 10.695-2.963 12.628-6.7s2.319-8.889 1.162-15.205c-3.093-0.258-7.087 1.159-11.855 4.123s-6.445 7.731-5.156 14.561c2.19-3.093 3.997-5.412 5.154-7.087 2.062-2.835 4.768-5.798 7.731-8.633 0.231-0.231 0.55-0.373 0.902-0.373 0.704 0 1.275 0.571 1.275 1.275 0 0.352-0.143 0.671-0.373 0.902v0c-2.668 2.557-5.117 5.291-7.347 8.202l-0.126 0.171q-3.092 4.255-10.438 14.692c-0.257 0.39-0.643 0.516-1.030 0.516-0.257 0-0.516-0.129-0.773-0.39-0.516-0.39-0.644-1.159-0.257-1.803 1.159-1.675 2.319-3.351 3.35-4.768-0.001 0-0.002 0-0.003 0-0.069 0-0.126-0.056-0.126-0.126 0-0.001 0-0.002 0-0.003v0c-2.319-9.016-0.257-15.459 5.798-19.328 5.927-3.734 10.695-5.151 14.56-4.378l0.903 0.129 0.129 0.903q2.319 11.017-1.16 17.781z"
});

var SvgEco = function SvgEco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eco.05747e0b.svg";
export { ForwardRef as ReactComponent };